export default {
    methods: {
        fetchRegistryData(colName, procName, responseType, where, afterAction, afterWhere){
            var test = false
            var vm = this;
            var resolving = function(collection, resolveFunction){
                if(responseType == "collection"){
                    console.log("resolved collection: ", colName)
                    resolveFunction(collection)
                } else {
                    var result;
                    if(afterWhere){
                        result = collection[afterAction](afterWhere);
                    } else {
                        result = collection.data;
                    }
                    resolveFunction(result)
                }
            }
            return new Promise(function(resolve, reject){
                if(false && vm.$Behaviors.useOffline){
                    var coll = vm.$root.dbRegistry.getCollection(colName);
                    resolving(coll, resolve)
                } else {
                    
                    var promise;
                    if(vm.$Behaviors.unusedCollections.indexOf(colName) != -1){
                        promise = new Promise(function(innerResolve, innerReject){
                            var data = {
                                body: []
                            }
                            console.log("unusedCollection: " + colName)
                            innerResolve(data);
                        })
                    } else if(!test){
                        var params = where ? {"where": where} : {}
                        params["idc"] = vm.token.idcliente;
                        promise = vm.$root.microservice({
                            serviceType: "registry",
                            role: "data",
                            cmd: procName,
                            params: params
                        })
                    } else {
                        promise = new Promise(function(innerResolve, innerReject){
                            setTimeout(function(){
                                var data = {
                                    body: []
                                }
                                console.log("resolved test data")
                                innerResolve(data);
                            }, 5000)
                        })
                    }
                    promise.then((response) => {
                        var res = response.body;
                        try {
                            res = JSON.parse(response.body);
                        } catch (err) {}
                        var db = vm.tempLoki()
                        var options = {};
                        for(var i = 0; i < vm.$root.registry.collections.length; i++){
                            var r = vm.$root.registry.collections[i];
                            if(r.name == colName){
                                if(r.opts) options = r.opts;
                                break;
                            }
                        }
                        var c = db.addCollection(colName, options);
                        if(res && res.length){
                            c.insert(res)
                        }
                        resolving(c, resolve)
                        
                    }, (err) => {
                        console.log("Error on registry proxy microservice: ", err)
                        vm.loadLoki("").then((db) => {
                            console.log("Error on registry proxy microservice: ", errr)
                            console.log(db)
                            var c = db.addCollection(colName);
                            resolving(c, resolve)
                        }, (err) => {
                            reject(err)
                        })
                    })
                }
            })
            
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/registry_proxy_mixin.js